import type { ReactNode } from "react";

import { MenuHeading } from "@/components/MenuHeading";

/**
 * The canonical top-of-page treatment, shared by all four friend-trading pages
 * (Potential / Proposed / Completed / Compare Dex).
 *
 * b19-ui-cosmetics: the single `pt-12 page-hero-top` hero wrapper used by
 * Profile / Friends / Trade / Pokedex (PR #271) — no stacked back-chip spacer,
 * so the eyebrow pill lines up pixel-for-pixel with every other top-level menu.
 * It exists as a component rather than four copies of the same two lines so
 * that alignment can only ever be changed in one place.
 *
 * The eyebrow is where each page names the friend it is about: these are all
 * per-friend pages, and without the name in the header they are four screens
 * that look the same for every trainer you open.
 */
export function TradePageHero({
  eyebrow,
  title,
  greenSuffix,
  subtitle,
  children,
}: {
  eyebrow: string;
  title: string;
  greenSuffix?: string;
  subtitle?: ReactNode;
  /** Rendered under the heading — the pane tabs on the hub pages. */
  children?: ReactNode;
}) {
  return (
    <div className="pt-12 page-hero-top">
      <MenuHeading
        eyebrow={eyebrow}
        title={title}
        greenSuffix={greenSuffix}
        subtitle={subtitle}
      />
      {children && <div className="mb-4">{children}</div>}
    </div>
  );
}
